export default __webpack_public_path__ + "static/media/joan-rolling.87038b1b.jpg";